export default __webpack_public_path__ + "static/media/HYRONPAY.cffdb3ce.png";